<div class="p-5">
    <div class="row box-center">
        <div class="col-12 col-lg-6 col-md-6">
            <img src="https://firebasestorage.googleapis.com/v0/b/bantrab-app.appspot.com/o/lobonegrobt.png?alt=media&token=6c88b4aa-cd97-425a-9990-3919ff97c2c7" alt="" height="35">
        </div>
        <div class="col-12 col-lg-6 col-md-6 box-sinapuros">
        </div>
    </div>
    <div class="container">
        <h1 class="text-sorry mt-5">¡Lo sentimos!</h1> <br> <br>
        <h1 class="text-number mt-5">404</h1> <br> <br>
        <p class="text-message mt-5 mb-5">No se ha encontrado la página que estás buscando.</p>
        <div class="text-center">
        </div>
    </div>

</div>

